/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bell_Unread_SrInputs */

const en_bell_unread_sr = /** @type {(inputs: Bell_Unread_SrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`unread`)
};

/**
* | output |
* | --- |
* | "unread" |
*
* @param {Bell_Unread_SrInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const bell_unread_sr = /** @type {((inputs?: Bell_Unread_SrInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bell_Unread_SrInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_bell_unread_sr(inputs)
});